import React, { createContext, useContext, useState } from 'react';

interface ImagesContextType {
  selectedImage: File | string | null; // The file or URL
  imageName: string | null; // Name of the image
  setSelectedImage: (image: File | string | null, name?: string | null) => void; // Set image and name
  clearSelectedImage: () => void; // Clear the image and name
  isGenerating: boolean;
  handleIsGenerating: (e: boolean) => void;
}

const ImagesContext = createContext<ImagesContextType | undefined>(undefined);

export const ImagesProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedImage, setSelectedImageState] = useState<File | string | null>(
    null
  );
  const [isGenerating, setIsGenerating] = useState(false);
  const [imageName, setImageName] = useState<string | null>(null);

  const setSelectedImage = (
    image: File | string | null,
    name: string | null = null
  ) => {
    setSelectedImageState(image);
    setImageName(name);
  };
  const handleIsGenerating = (e: boolean) => {
    setIsGenerating(e);
  };

  const clearSelectedImage = () => {
    setSelectedImageState(null);
    setImageName(null);
  };

  return (
    <ImagesContext.Provider
      value={{
        selectedImage,
        imageName,
        setSelectedImage,
        clearSelectedImage,
        handleIsGenerating,
        isGenerating,
      }}
    >
      {children}
    </ImagesContext.Provider>
  );
};

export const useImagesContext = (): ImagesContextType => {
  const context = useContext(ImagesContext);
  if (!context) {
    throw new Error('useImagesContext must be used within an ImagesProvider');
  }
  return context;
};
